import { Globe, Instagram, Facebook, Twitter } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SocialLinksProps {
  socials?: {
    tiktok?: string;
    facebook?: string;
    instagram?: string;
    x?: string;
    website?: string;
  };
}

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
    <path d="M19.321 5.562a5.124 5.124 0 0 1-.443-.258 6.228 6.228 0 0 1-1.137-.966c-.849-.849-1.382-2.011-1.382-3.266C16.359.619 15.74 0 15.008 0h-2.68c-.732 0-1.351.619-1.351 1.351v10.384c0 1.492-1.208 2.7-2.7 2.7s-2.7-1.208-2.7-2.7 1.208-2.7 2.7-2.7c.242 0 .476.032.698.091V6.264c-.222-.024-.448-.039-.698-.039C4.57 6.225 1.5 9.296 1.5 13.012s3.07 6.787 6.787 6.787 6.787-3.07 6.787-6.787V7.598a8.124 8.124 0 0 0 4.746 1.52v-2.68c0-.732-.619-1.351-1.351-1.351a3.369 3.369 0 0 1-1.148-.525z"/>
  </svg>
);

export const SocialLinks = ({ socials }: SocialLinksProps) => {
  if (!socials || Object.keys(socials).length === 0) return null;

  const socialPlatforms = [
    {
      key: 'instagram' as keyof typeof socials,
      icon: Instagram,
      label: 'Instagram', 
      color: 'hover:text-pink-400'
    },
    {
      key: 'facebook' as keyof typeof socials,
      icon: Facebook,
      label: 'Facebook',
      color: 'hover:text-blue-500'
    },
    {
      key: 'x' as keyof typeof socials,
      icon: Twitter,
      label: 'X (Twitter)',
      color: 'hover:text-gray-400'
    },
    {
      key: 'tiktok' as keyof typeof socials,
      icon: TikTokIcon,
      label: 'TikTok',
      color: 'hover:text-black'
    }
  ];

  const availableSocials = socialPlatforms.filter(platform => socials[platform.key]);

  if (availableSocials.length === 0) return null;

  return (
    <div className="flex gap-3 flex-wrap">
      {availableSocials.map(({ key, icon: Icon, label, color }) => (
        <Button
          key={key}
          variant="ghost"
          size="sm"
          asChild
          className={`rounded-full bg-white/10 hover:bg-white/20 text-white/80 ${color} transition-all duration-300 backdrop-blur-sm border border-white/10`}
        >
          <a
            href={socials[key]}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${label} profile`}
            title={label}
          >
            <Icon className="w-4 h-4" />
          </a>
        </Button>
      ))}
    </div>
  );
};